import React, { Component } from "react";
import Button from "@bonprix/pattern-library/templates/button/default";
import Icon from "@bonprix/pattern-library/templates/icon";
import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from "@bonprix/pattern-library/components/messages";
import DropdownContent from "@bonprix/pattern-library/templates/dropdown/dropdown-content";

export default class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
      isExpanded: false,
    };

    this.subs = [];

    this.buttonClick = this.buttonClick.bind(this);
    this.handlePressingEscape = this.handlePressingEscape.bind(this);
    this.handleClickForClosing = this.handleClickForClosing.bind(this);
    this.closeDropdownItemAndDeactivateTheClickListenersForClosing =
      this.closeDropdownItemAndDeactivateTheClickListenersForClosing.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  dropdownLabelClick(event) {
    if (!this.state.isOpened) {
      this.setState({ isOpened: true });
      this.activateListenersToCloseDropdownItemLater(event);
    } else {
      this.closeDropdownItemAndDeactivateTheClickListenersForClosing();
    }
    if (this.props.onLabelClick) {
      this.props.onLabelClick(!this.state.isOpened);
    }
  }

  buttonClick(event) {
    this.props.buttonOnClick(event);
  }

  componentDidUpdate(previousProps, previousState, snapshot) {
    if (this.state.isOpened && this.state.isOpened !== previousState.isOpened) {
      this.setState({ isExpanded: this.checkIfDropdownIsExpanded() });
    }
  }

  componentWillUnmount() {
    if (this.state.isOpened) {
      this.closeDropdownItemAndDeactivateTheClickListenersForClosing();
    }
  }

  render() {
    const openedClass = this.state.isOpened ? "-is-opened" : "";
    const expandedClass = this.state.isExpanded ? "-is-expanded" : "";

    let dropdownItemAttributes = {
      "jsh-input__wrapper": "true",
      "jsh-dropdown-item": "true",
    };

    if (this.props.customJsh) {
      let customHookName = "jsh-" + this.props.customJsh;
      if (this.props.dropdownIndex) {
        customHookName += "-" + this.props.dropdownIndex;
      }

      const customHookObj = { [customHookName]: "true" };
      dropdownItemAttributes = { ...dropdownItemAttributes, ...customHookObj };
    }

    return (
      <div className={`${this.props.dropdownItemClass} dropdown__wrapper`}>
        <div
          className={`dropdown-item ${openedClass} ${expandedClass}`}
          {...dropdownItemAttributes}
          ref={(dropdownItem) => (this.dropdownItem = dropdownItem)}
        >
          <label
            htmlFor={this.props.dropdownName}
            onClick={(e) => this.dropdownLabelClick(e)}
            className="dropdown__label input-group__field"
            jsh-dropdown-label="true"
          >
            <div className="input" jsh-input="true">
              <span className="dropdown__label-text">
                {this.props.visibleLabel}
              </span>
              <span className="dropdown__arrow input__icon--select">
                <Icon name="arrow-down" />
              </span>
            </div>
          </label>
          {this.state.isOpened ? (
            <div
              className="dropdown__content-wrapper"
              jsh-dropdown-content-wrapper="true"
              ref={(dropdownContent) =>
                (this.dropdownContent = dropdownContent)
              }
            >
              <DropdownContent
                children={this.props.children}
                disabled={this.props.disabled}
              />
              {this.props.showButton ? (
                this.renderButton(
                  this.props.buttonText,
                  this.props.buttonId,
                  this.props.buttonCustomJsh,
                  this.props.disabled
                )
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }

  renderButton(buttonText, buttonId, buttonCustomJsh, disabled) {
    let buttonAttributes = { "jsh-dropdown-submit-button": "true" };
    if (buttonCustomJsh) {
      let buttonCustomHookName = "jsh-" + buttonCustomJsh;
      const buttonCustomHookObj = { [buttonCustomHookName]: "true" };
      buttonAttributes = { ...buttonAttributes, ...buttonCustomHookObj };
    }
    return (
      <Button
        className="dropdown__submit-button"
        id={buttonId}
        attributes={buttonAttributes}
        onClick={this.buttonClick}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    );
  }

  activateListenersToCloseDropdownItemLater(event) {
    // offers press esc to close dropdowns
    document.addEventListener("keydown", this.handlePressingEscape);

    // offers click somewhere to close dropdowns
    document.body.addEventListener("click", this.handleClickForClosing);

    this.subs.push(
      MessageBroker.subscribe(
        Messages.DROPDOWN.CLOSE,
        this.closeDropdownItemAndDeactivateTheClickListenersForClosing
      )
    );
    this.subs.push(
      MessageBroker.subscribe(Messages.WINDOW.RESIZED, this.handleResize)
    );
  }

  handlePressingEscape(event) {
    if (
      event.target.nodeName === "BODY" &&
      (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27)
    ) {
      this.closeDropdownItemAndDeactivateTheClickListenersForClosing();
    }
  }

  handleClickForClosing(event) {
    if (!this.dropdownItem.contains(event.target)) {
      this.closeDropdownItemAndDeactivateTheClickListenersForClosing();
    }
  }

  closeDropdownItemAndDeactivateTheClickListenersForClosing() {
    // close dropdownItem
    this.setState({ isOpened: false });

    // deactivate click listeners for closing
    document.removeEventListener("keydown", this.handlePressingEscape);
    document.body.removeEventListener("click", this.handleClickForClosing);
    this.subs.forEach((sub) => MessageBroker.unsubscribe(sub));
  }

  checkIfDropdownIsExpanded() {
    return this.dropdownItem.offsetWidth !== this.dropdownContent.offsetWidth;
  }

  handleResize() {
    if (this.checkIfDropdownIsExpanded() !== this.state.isExpanded) {
      this.setState({ isExpanded: !this.state.isExpanded });
    }
  }
}
